/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_DescriptionInputs */



/**
* | output |
* | --- |
* | "Vessel inspections and vetting, condition surveys, marine consultancy and OCIMF management-system audits from accredited Master Mariners and Chief Engineers." |
*
* @param {Services_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const services_description = /** @type {((inputs?: Services_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("由认证船长和轮机长提供船舶检查与审查、状况检验、海事咨询以及 OCIMF 管理体系审核。")
	return /** @type {LocalizedString} */ ("Vessel inspections and vetting, condition surveys, marine consultancy and OCIMF management-system audits from accredited Master Mariners and Chief Engineers.")
});